import ProductForList, { ProductForListTypes } from '../../components/ProductComponents/ProductForList';

interface Props  {
    category: any,
    locationCode:string
}
export default function ProductsRowCategoryBlock(props: Props) {
    const products:any[] = props.category.items


    if (products.length === 0)
        return <></>
    return <div className="products-block-gray">
        <div>
            <div className="title">
                {props.category.title}
            </div>
        </div>
        <div className="d-flex flex-row overflow-auto products-list">
            {products.map((item: any, index: number) => (
                <div className="col-6 col-md-4 pt-2 pb-2" key={index}>
                    <ProductForList product={item} type={ProductForListTypes.Full} locationCode={props.locationCode} />
                </div>
            ))}
        </div>
    </div>
}
